module.exports = __webpack_public_path__ + "img/shezhi.425df928.png";